export default __webpack_public_path__ + "static/media/Logo_Queiroz.2923087d.jpg";